<template>
	<div class="all">
		<div  class="denglu_dl1">
			<div  class="denglu_dl2">
				
				<div style="font-size: 22px;text-align: center;">左福右利2.0核销系统（浪卡卡）</div>
				
				<div  class="denglu_dl3">
					<div class="iconfont iconrenwu denglu_dl4" ></div>
					<input type="text" placeholder="请输入账号" v-model="form.zhanghao">
				</div>
				<div class="denglu_dl3">
					<div class="iconfont iconmima denglu_dl4" ></div>
					<input type="password" placeholder="请输入密码" v-model="form.mima" @keyup.enter="Tijiao()">
				</div>
			<!-- 	<div  class="denglu_dl5">
					<el-checkbox>自动登录</el-checkbox>
				</div> --> 
				<div @click="Tijiao"  class="denglu_dl6 " style="margin-top: 30px;">登陆</div>
				
				<!-- <div style="font-size: 16px;padding-top: 20px;color: #409EFF;">左福右利标准版核销系统</div>
				<div style="font-size: 16px;padding-top: 20px;color: #E6A23C;">左福右利臻享版核销系统</div> -->
				<!-- 链接存在 -->
				<!-- <div   class="zfyl00 " style="margin-top: 10px;background-color: #67C23A;"><a href="https://store_cash.fxqifu.com/welcome/login/1004119" target="_Blank">左福右利臻享版核销系统</a></div> -->
				<!-- <div  class="zfyl00 " style="margin-top: 10px;background-color: #E6A23C;"><a href="https://store_cash.fxqifu.com/welcome/login/1002125" target="_Blank">左福右利标准版核销系统	</a></div> -->
			<!-- 链接不存在 -->
			<!-- <div   class="zfyl00 " style="margin-top: 10px;background-color: #67C23A;cursor: pointer">左福右利臻享版核销系统</div> -->
			<!-- <div  class="zfyl00 " style="margin-top: 10px;background-color: #E6A23C;cursor: pointer">左福右利标准版核销系统</div> -->
			
			<!-- 	<div  style='margin-top:10px'>
					<a href="https://store_cash.fxqifu.com/welcome/login/1004119" target="_Blank"><el-button type="success"   >左福右利臻享版核销系统</el-button></a>
				</div>
				<div style='margin-top:10px'>
					<a href="https://store_cash.fxqifu.com/welcome/login/1002125" target="_Blank"><el-button type="primary"  >左福右利标准版核销系统	</el-button></a>
				</div> -->
				
				<!-- <div  class="denglu_dl7">
					<url href="zhuce"  class="denglu_dl8">立即注册</url>
					<url  class="denglu_dl9">忘记密码</url>
				</div> -->
				
				
			<!-- 	<div style="display: flex;justify-content: space-between;">
					<url href="zhuce"  class="denglu_dl8">立即注册</url>
					<url  class="denglu_dl9">忘记密码</url>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	var that;
	export default {
		data() {
			return {
				form: {},
				urls:''
			}
		},
		created: function() {
			that = this;
		},
		methods: {
			Tijiao() {
				// if(that.form.zhanghao.indexOf('zong1_')>=0){
				// 	console.log(111)
				// 	that.urls='https://langkaka3.myuan.cc/shanghu.php?d=33'
				// 	that.$cun('urlss', that.urls);
				// }else if(that.form.zhanghao.indexOf('zong2_')>=0){
				// 	that.urls='https://langkaka4.myuan.cc/shanghu.php?d=33'
				// 	that.$cun('urlss', that.urls);
				// 	console.log(222)
				// }else{
				// 	that.$cun('urlss', '');
				// }
				that.$post('k=denglu', that.form, function(s) {
					if (s.shi == 1) {
						that.$quanju('$shanghu',s.shu);
						that.$cun('shanghu', s.shu);
						
						that.$dakai('/');
						
					} else {
						that.$message.error(s.shu);
					}
				})
			}
		}
	}
</script>

<style>
	.all {
		background: url(../../assets/denglu.png)no-repeat;
		background-size: cover;
		width: 100%;
		height: 100vh;
		position: relative;
	}

	input {
		background: none;
		outline: none;
		border: none;
	}
.denglu_dl1{width:500px;height:400px;background:rgba(255,255,255,1);border-radius:30px;box-shadow:0px 0px 10px 0px rgba(224,224,224,1);position: absolute; margin-top: -200px;top: 50%;left: 50%;margin-left: -250px;}
.denglu_dl2{padding:57px  74px 0 83px ;}
.denglu_dl3{height: 60px;display: flex;border-bottom: 1px solid #EBEBEB;align-items: center;width: 320px;}
.denglu_dl4{color: #00BFFF;font-size: 15px;padding-right: 19px;}
.denglu_dl5{height: 60px;display: flex;align-items: center;width: 320px;}
.denglu_dl6{width:360px;height:40px;background:rgba(0,123,255,1);border-radius:34px;display: flex;align-items: center;justify-content: center;margin: 0 auto;font-size:14px;color:rgba(255,255,255,1);font-weight:400;}
.denglu_dl7{display: flex;justify-content: center;padding-top: 20px;}
.denglu_dl8{padding-right: 48px;color: #007BFF;font-size:9px;font-weight:400;}
.denglu_dl9{color: #007BFF;font-size:9px;font-weight:400;color:rgba(153,153,153,1);}

.zfyl00{width:360px;height:40px;border-radius:34px;display: flex;align-items: center;justify-content: center;margin: 0 auto;font-size:14px;color:rgba(255,255,255,1);font-weight:400;}

 /*包含以下四种的链接*/
 a {
	 color:#fff;
     text-decoration: none;
 }
 /*正常的未被访问过的链接*/
 a:link {
     text-decoration: none;
 }
 /*已经访问过的链接*/
 a:visited {
     text-decoration: none;
 }
 /*鼠标划过(停留)的链接*/
 a:hover {
     text-decoration: none;
 }
 /* 正在点击的链接*/
 a:active {
     text-decoration: none;
 }

</style>
